import { useEffect, useState } from 'react'

type Scene = {
  name: string
  frames: readonly number[]
  frameMs: number
  durationMs: number
}

const awakeScenes: readonly Scene[] = [
  { name: 'sit', frames: [0, 1, 2, 1], frameMs: 500, durationMs: 8000 },
  { name: 'groom', frames: [12, 13], frameMs: 500, durationMs: 5000 },
  { name: 'sit', frames: [0, 1, 2, 1], frameMs: 500, durationMs: 10000 },
  { name: 'play', frames: [20, 21, 22, 21], frameMs: 320, durationMs: 6000 }
]

const sleepScene: Scene = {
  name: 'sleep',
  frames: [10, 11],
  frameMs: 1400,
  durationMs: Infinity
}

const AWAKE_DURATION_MS = awakeScenes.reduce((s, x) => s + x.durationMs, 0)
const SHEET_FRAMES = 23

export const Cat = () => {
  const [awake, setAwake] = useState(false)
  const [sceneIdx, setSceneIdx] = useState(0)
  const [frameIdx, setFrameIdx] = useState(0)
  const [reduceMotion, setReduceMotion] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)')
    setReduceMotion(mq.matches)
    const onChange = (e: MediaQueryListEvent) => setReduceMotion(e.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  const scene = awake ? awakeScenes[sceneIdx] : sleepScene

  useEffect(() => {
    if (reduceMotion) return
    const id = window.setInterval(() => {
      setFrameIdx((i) => i + 1)
    }, scene.frameMs)
    return () => window.clearInterval(id)
  }, [scene, reduceMotion])

  useEffect(() => {
    if (reduceMotion || !awake) return
    const id = window.setTimeout(() => {
      setSceneIdx((i) => (i + 1) % awakeScenes.length)
      setFrameIdx(0)
    }, scene.durationMs)
    return () => window.clearTimeout(id)
  }, [sceneIdx, scene.durationMs, awake, reduceMotion])

  useEffect(() => {
    if (!awake) return
    const id = window.setTimeout(() => {
      setAwake(false)
      setSceneIdx(0)
      setFrameIdx(0)
    }, AWAKE_DURATION_MS)
    return () => window.clearTimeout(id)
  }, [awake])

  const currentFrame = reduceMotion
    ? awake
      ? 0
      : 10
    : scene.frames[frameIdx % scene.frames.length]

  const positionX = (currentFrame * 100) / (SHEET_FRAMES - 1)

  const wake = () => {
    setAwake(true)
    setSceneIdx(0)
    setFrameIdx(0)
  }

  return (
    <button
      type="button"
      onClick={wake}
      disabled={awake}
      aria-label={awake ? '起きている猫' : '猫を起こす'}
      title={awake ? '起きている' : '猫を起こす'}
      className="fixed bottom-3 left-3 sm:bottom-6 sm:left-6 w-16 h-16 sm:w-24 sm:h-24 appearance-none border-0 p-0 select-none z-[60] cursor-pointer disabled:cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-ink-400 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-50 rounded"
      style={{
        backgroundImage: 'url(/cat.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: `${SHEET_FRAMES * 100}% 100%`,
        backgroundPosition: `${positionX}% 0`,
        backgroundColor: 'transparent',
        imageRendering: 'pixelated'
      }}
    />
  )
}
